<template>
  <tabs parent="diadoc">
    <tab
        id="documents"
        :name="translate('diadoc.tabs.documents')"
        :href="url+'documents'"
    >
      <Documents :department_list="department_list"/>
    </tab>

    <tab
        id="counterparties"
        :name="translate('diadoc.tabs.counterparties')"
        :href="url+'counterparties'"
    >
      <Counterparties />
    </tab>

    <tab
        id="departments"
        :name="translate('diadoc.tabs.departments')"
        :href="url+'departments'"
    >
      <Departments :departments="departments"/>
    </tab>

    <tab
        id="policies"
        :name="translate('diadoc.tabs.policies')"
        :href="url+'policies'"
    >
      <Policies />
    </tab>

    <tab
        id="history"
        :name="translate('diadoc.tabs.history')"
        :href="url+'history'"
    >
      <History />
    </tab>

  </tabs>
</template>

<script>

import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Documents from './Tabs/Documents/Documents.vue'
import Counterparties from './Tabs/Counterparties/Counterparties.vue'
import Departments from './Tabs/Departments/Departments.vue'
import Policies from "./Tabs/Policies/Policies.vue";
import History from "./Tabs/History/History.vue";


export default {
  name: 'Diadoc',
  components:{
    Tab,
    Tabs,
    Documents,
    Counterparties,
    Departments,
    Policies,
    History
  },
  props: {
  },
  data () {
    return {
      load: true,
      departments: []
    }
  },
  computed: {
    url () { return '/diadoc/' },
    department_list(){
      return this.departments.map(item => {
        return { id: item.department_id, label: item.name}
      })
    }
  },

  created () {
    this.get_diadoc_department_list()
  },

  methods: {
    get_diadoc_department_list(){
      this.$http.v1.getDiadocDepartmentList((response) => {
        this.departments = response.data
      })
    },
  }

}
</script>
